import React, { forwardRef, useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// react-google-recaptcha hands `hl` to Google only when the widget is first rendered, so a
// language switch leaves the widget in the old language. Keying on the locale remounts it in the
// new one. The remount throws away a solved challenge, so report the token as cleared.
const ReCaptcha = forwardRef(({ onChange, ...props }, ref) => {
  const { locale } = useIntl();
  const renderedLocale = useRef(locale);

  useEffect(() => {
    if (renderedLocale.current === locale) return;
    renderedLocale.current = locale;
    if (onChange) onChange(null);
  }, [locale]);

  return <ReCAPTCHA {...props} key={locale} ref={ref} hl={locale} onChange={onChange} />;
});

ReCaptcha.propTypes = {
  onChange: PropTypes.func,
};

ReCaptcha.defaultProps = {
  onChange: undefined,
};

export default ReCaptcha;
